<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - '+routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <h4 class="color-secundary">Informe de estado de reclamación</h4>
      <br />
      <div class="col text-center" v-if="loading" style="padding-top: 100px">
        Por favor espere mientras consultamos los datos...
        <img src="@/assets/images/loader.gif" alt />
      </div>
      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->

      <div class="col text-center" v-if="dataLength < 1 && !loading">
        No se encontraron datos para mostrar
      </div>
      <div class="col" v-for="chart in data" :key="chart.convenio">
        <h4 style="padding-top: 20px" v-if="chart.modelo == 1">
          Respaldo FGA
        </h4>
        <h4 style="padding-top: 20px" v-else>Cobertura Integral</h4>
        <p style="font-style: oblique;">
          {{ "Fecha limite pago: " + chart.fecha_limite_pago }}
        </p>
        <Charts :data="chart" :labels="chart.labels" :series="chart.series" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      data: [],
      loading: false,
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
    Charts: () => import("@/components/Charts")
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
    }),
    dataLength() {
      return this.data.length;
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    async index(){
      this.loading = true;
      let response = await this.$store.state.api.get(
        "informes/estado_reclamacion",
        {
          params: {
            //
          },
        }
      ).then((data) => {
        let datos = data.data.datos;
        datos.forEach((element, index) => {
          element.labels.forEach((label, key) => {
            let label_name = "";
            if(label == "en_revision"){
              label_name = "En revisión";
            }else if(label == "devolucion"){
              label_name = "Devolución";
            }else{
              label_name = this.capitalizeFirstLetter(label);
            }
            datos[index].labels[key] = label_name;
          });
        });
        this.data = datos;
        this.loading = false;
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      })

    },
    clickEvent() {},
    capitalizeFirstLetter(str) {
      let words = str.split('_');
      words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
      return words.join(' ');
    }
  },
  mounted() {
    this.index();
  },
};
</script>
